import { useEffect } from 'react';

const PerformanceOptimizer = () => {
  useEffect(() => {
    // Nur in Produktion ausführen
    if (process.env.NODE_ENV === 'test' || typeof window === 'undefined') {
      return;
    }

    // Lazy load non-critical resources
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        // Load non-critical CSS or JS here if needed
      });
    }

    // Prefetch next likely pages
    const prefetchPages = ['/busse'];
    prefetchPages.forEach((href) => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    });

    // Service Worker für bessere Caching-Strategien
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      });
    }
  }, []);

  return null; // This component doesn't render anything
};

export default PerformanceOptimizer;
